import { useDispatch, useSelector } from "react-redux";
import CommonHeader from "../Sub/CommonHeader";
import { Container, Row } from "react-bootstrap";
import moment from "moment";
import { useEffect } from "react";
import { smsErrorLogs } from "../../reducers/commonReducer";

export default function SmsErrorLogs() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(smsErrorLogs());
  }, []);
  const { smsErrorLogList } = useSelector((state) => state.commonReducer);
  return (
    <>
      <CommonHeader />
      <div className="container-fluid">
        <Row className="">
          <Container className="r-main-tbl mt-3">
            <div className="timeline-container">
              {smsErrorLogList?.map((item, index) => {
                return (
                  <>
                    {
                      <div key={index} className="timeline-item">
                        <div className="timeline-dot text-danger bg-danger" />
                        <div className="timeline-content border-danger py-4">
                          <h3>
                            <b>{item.code}</b> : <b>{item?.resp}</b>
                            <span>
                              {moment(item?.date).format(
                                "ddd, D MMMM YY, HH:mm:ss"
                              )}
                            </span>
                          </h3>
                          <p>{item?.comment}</p>
                        </div>
                      </div>
                    }
                  </>
                );
              })}
            </div>
          </Container>
        </Row>
      </div>
    </>
  );
}
